import {QueryKey, useQuery} from 'react-query';
import camelcaseKeys from 'camelcase-keys';

import {getStat} from 'client/common/utils/api-client/constructor';

import {SurveyState} from 'client/common/store/reducers/survey/types';
import {CreativeStat, SurveySlug} from 'client/common/types';

const CREATIVE_STAT_KEY = 'creativeStat';

export function getCreativeStatKey(slug: SurveySlug, state: SurveyState | undefined): QueryKey {
    return [CREATIVE_STAT_KEY, slug, state];
}

export function useCreativeStat(slug: SurveySlug, state: SurveyState | undefined) {
    return useQuery(getCreativeStatKey(slug, state), async () => {
        if (state === 'COMPLETED') {
            const {data} = await getStat({slug, type: 'creative'});

            // @ts-ignore
            return camelcaseKeys(data, {deep: true}) as CreativeStat | undefined;
        }
    });
}
